import React, { useState } from "react";

function InterviewRemarksStatusModal({ title, onClose, modalData }) {
  return (
    <>
      <div
        className="modal fade show"
        tabIndex="-1"
        style={{ display: "block" }}
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content shadow rounded-4">
            <div className="modal-header">
              <h5 className="mb-0">{title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>
            <div className="modal-body fs-9">
              <div className="mb-2 d-flex justify-content-between">
                <strong>Interview Taken:</strong>
                <div>{modalData.isInterviewTaken ? "Yes" : "No"}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Interview Date:</strong>
                <div>{modalData.interviewDate?.split("T")[0]}</div>
              </div>
              <div className="mb-2 d-flex justify-content-between">
                <strong>Interview Remarks:</strong>
                <div>{modalData.interviewRemarks}</div>
              </div>
              <div className="text-center mt-4">
                <button
                  className="btn btn-primary btn-sm w-100 rounded-pill"
                  onClick={onClose}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default InterviewRemarksStatusModal;
